export const esPrimeVueTranslations = {
  startsWith: 'Comienza con',
  contains: 'Contiene',
  notContains: 'No contiene',
  endsWith: 'Termina con',
  equals: 'Igual a',
  notEquals: 'Diferente de',
  noFilter: 'Sin filtro',
  lt: 'Menor que',
  lte: 'Menor o igual a',
  gt: 'Mayor que',
  gte: 'Mayor o igual a',
  dateIs: 'Fecha es',
  dateIsNot: 'Fecha no es',
  dateBefore: 'Fecha es anterior a',
  dateAfter: 'Fecha es posterior a',
  clear: 'Limpiar',
  apply: 'Aplicar',
  matchAll: 'Coincidir con todos',
  matchAny: 'Coincidir con cualquiera',
  addRule: 'Agregar regla',
  removeRule: 'Eliminar regla',
  accept: 'Sí',
  reject: 'No',
  choose: 'Elegir',
  upload: 'Subir',
  cancel: 'Cancelar',
  completed: 'Completado',
  pending: 'Pendiente',
  fileSizeTypes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
  dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
  dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
  dayNamesMin: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
  monthNames: [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ],
  monthNamesShort: [
    'Ene',
    'Feb',
    'Mar',
    'Abr',
    'May',
    'Jun',
    'Jul',
    'Ago',
    'Sep',
    'Oct',
    'Nov',
    'Dic',
  ],
  chooseYear: 'Elegir Año',
  chooseMonth: 'Elegir Mes',
  chooseDate: 'Elegir Fecha',
  prevDecade: 'Década Anterior',
  nextDecade: 'Próxima Década',
  prevYear: 'Año Anterior',
  nextYear: 'Próximo Año',
  prevMonth: 'Mes Anterior',
  nextMonth: 'Próximo Mes',
  prevHour: 'Hora Anterior',
  nextHour: 'Próxima Hora',
  prevMinute: 'Minuto Anterior',
  nextMinute: 'Próximo Minuto',
  prevSecond: 'Segundo Anterior',
  nextSecond: 'Próximo Segundo',
  am: 'am',
  pm: 'pm',
  today: 'Hoy',
  weekHeader: 'Sem',
  firstDayOfWeek: 0,
  showMonthAfterYear: false,
  dateFormat: 'dd/mm/yy',
  weak: 'Débil',
  medium: 'Media',
  strong: 'Fuerte',
  passwordPrompt: 'Ingrese una contraseña',
  searchMessage: '{0} resultados disponibles',
  selectionMessage: '{0} elementos seleccionados',
  emptySelectionMessage: 'Ningún elemento seleccionado',
  emptySearchMessage: 'No se encontraron resultados',
  fileChosenMessage: '{0} archivos',
  noFileChosenMessage: 'Ningún archivo elegido',
  emptyMessage: 'Sin opciones disponibles',
  aria: {
    trueLabel: 'Verdadero',
    falseLabel: 'Falso',
    nullLabel: 'No Seleccionado',
    star: '1 estrella',
    stars: '{star} estrellas',
    selectAll: 'Todos los elementos seleccionados',
    unselectAll: 'Todos los elementos deseleccionados',
    close: 'Cerrar',
    previous: 'Anterior',
    next: 'Siguiente',
    navigation: 'Navegación',
    scrollTop: 'Desplazar al Inicio',
    moveTop: 'Mover al Inicio',
    moveUp: 'Mover Arriba',
    moveDown: 'Mover Abajo',
    moveBottom: 'Mover al Final',
    moveToTarget: 'Mover al Destino',
    moveToSource: 'Mover al Origen',
    moveAllToTarget: 'Mover Todos al Destino',
    moveAllToSource: 'Mover Todos al Origen',
    pageLabel: 'Página {page}',
    firstPageLabel: 'Primera Página',
    lastPageLabel: 'Última Página',
    nextPageLabel: 'Próxima Página',
    prevPageLabel: 'Página Anterior',
    rowsPerPageLabel: 'Filas por página',
    jumpToPageDropdownLabel: 'Ir a Página Dropdown',
    selectRow: 'Fila Seleccionada',
    unselectRow: 'Fila No Seleccionada',
    expandRow: 'Fila Expandida',
    collapseRow: 'Fila Contraída',
    showFilterMenu: 'Mostrar Menú de Filtro',
    hideFilterMenu: 'Ocultar Menú de Filtro',
    filterOperator: 'Operador de Filtro',
    filterConstraint: 'Restricción de Filtro',
    editRow: 'Editar Fila',
    saveEdit: 'Guardar Edición',
    cancelEdit: 'Cancelar Edición',
    listView: 'Vista de Lista',
    gridView: 'Vista de Cuadrícula',
    slide: 'Deslizar',
    slideNumber: '{slideNumber}',
    zoomImage: 'Ampliar Imagen',
    zoomIn: 'Acercar',
    zoomOut: 'Alejar',
    rotateRight: 'Girar a la Derecha',
    rotateLeft: 'Girar a la Izquierda',
  },
}
